import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
    margin: "20px",
    borderRadius: "4px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: 50,
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: 255,
    display: "block",
    maxWidth: 400,
    overflow: "hidden",
    width: "80%",
  },
  card: {
    boxShadow: "unset !important",
  },
  Carousel: {
    width: "80%",
  },
}));

const Item = ({ small_image_bin_value, file_name }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.card}>
      <img
        className="img"
        src={"data:image/jpeg;base64," + small_image_bin_value}
        alt={file_name}
      />
    </Paper>
  );
};

function SwipeableTextMobileStepper(props) {
  const classes = useStyles();

  useEffect(() => {
    // console.log(" props.images", props.images);
  }, []);

  return (
    <div className={classes.root}>
      <Carousel
        className={classes.Carousel}
        navButtonsAlwaysVisible={true}
        autoPlay={false}
        navButtonsProps={{
          style: {
            backgroundColor: "white",
            color: "gray",
          },
        }}
        indicators={{style:{fontSize:"11px"}}}
        indicatorIconButtonProps={{
          style: {
            padding: "5px", // 1
            border: "1px solid #ccc",
            margin: "0px 3px",
            color:"white", 
            width: "12px",
            height: "12px"
          },
        }}
        activeIndicatorIconButtonProps={{
          style: {
            color: "#1589ee",
            background:"#1589ee"
          },
        }}
        
      >
        {props.images &&
          props.images.map((item, i) => <Item key={i} {...item} />)}
      </Carousel>
    </div>
  );
}

export default SwipeableTextMobileStepper;
